import { Injectable, inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class TabTitleService {
    private document = inject(DOCUMENT);

    private originalTitle = '';
    private marqueeInterval: any = null;
    private awayMessage = '  ¡No te vayas! 🌸 Vuelve   ¡No te vayas! 🌸 Vuelve    ¡No te vayas! 🌸 Vuelve    ¡No te vayas! 🌸 Vuelve ';

    initTabTitleListener() {
        this.originalTitle = this.document.title;

        this.document.addEventListener('visibilitychange', () => {
            if (this.document.hidden) {
                this.originalTitle = this.document.title;
                this.startMarquee();
            } else {
                this.stopMarquee();
            }
        });
    }

    private startMarquee() {
        let text = this.awayMessage;

        // Rota el texto cada 200ms para crear el efecto de movimiento
        this.marqueeInterval = setInterval(() => {
            text = text.substring(1) + text.substring(0, 1);
            this.document.title = text;
        }, 500);
    }

    private stopMarquee() {
        if (this.marqueeInterval) {
            clearInterval(this.marqueeInterval);
            this.marqueeInterval = null;
        }
        // Restaura el título original
        this.document.title = this.originalTitle;
    }
}